import { render } from "./ClaimProduct.vue?vue&type=template&id=1596f08e&scoped=true"
import script from "./ClaimProduct.vue?vue&type=script&lang=js"
export * from "./ClaimProduct.vue?vue&type=script&lang=js"

import "./ClaimProduct.vue?vue&type=style&index=0&id=1596f08e&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1596f08e"]])

export default __exports__